// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202512181533/js/" + chunkId + "." + {"44":"9f367488","225":"63931d36","481":"0e37523b","486":"f28f3807","770":"bffac9fc"}[chunkId] + ".0.9002240060177564.chunk.js";
};